import axios from "axios";
import * as types from "../types";

const API_URL = types.API_BASE_URL + "auth/login-verify";

const state = {
  user: localStorage.user ? JSON.parse(localStorage.user) : null,
  token: localStorage.token || null,
  isLoggedIn: localStorage.token ? true : false,
  section: 0,
  detail: {},
  content: [],
  quiz: [],
  quiz_result: {},
  tryout: [],
  tryout_result: {},
  tryout_ongoing: null,
  new_notif: 0
};

const getters = {
  [types.IS_LOGGED_IN]: state => {
    return state.isLoggedIn;
  },
  [types.USER]: state => {
    return state.user;
  },
  [types.SECTION]: state => {
    return state.detail;
  },
  [types.CONTENT]: state => {
    return state.content;
  },
  [types.QUIZ]: state => {
    return state.quiz;
  },
  [types.QUIZ_RESULT]: state => {
    return state.quiz_result;
  },
  [types.TRYOUT]: state => {
    return state.tryout;
  },
  [types.TRYOUT_ONGOING]: state => {
    return state.tryout_ongoing;
  },
  [types.TRYOUT_RESULT]: state => {
    return state.tryout_result;
  },
  [types.NEW_NOTIF]: state => {
    return state.new_notif;
  }
};

const mutations = {
  [types.MUTATE_LOGIN]: (state, payload) => {
    localStorage.token = payload.token;
    localStorage.user = JSON.stringify(payload.data);
    state.user = payload.data;
    state.token = payload.token;
    state.isLoggedIn = true;
    state.is_admin = payload.data.is_admin ? 1 : 0;
    state.is_student = payload.data.is_student ? 1 : 0;
    state.is_teacher = payload.data.is_teacher ? 1 : 0;
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.token;
  },
  [types.MUTATE_LOGOUT]: state => {
    state.user = null;
    state.token = null;
    state.isLoggedIn = false;
    state.is_admin = null;
    state.is_student = null;
    state.is_teacher = null;
    state.content = [];
    state.quiz = [];
    state.quiz_result = {};
    state.tryout = [];
    state.tryout_result = {};
    state.tryout_ongoing = null
    localStorage.clear();
    axios.defaults.headers.common["Authorization"] = "";
  },
  [types.MUTATE_SECTION]: (state, payload) => {
    state.detail = payload;
  },
  [types.MUTATE_CONTENT]: (state, payload) => {
    state.content = payload;
  },
  [types.MUTATE_QUIZ]: (state, payload) => {
    state.quiz = payload;
  },
  [types.MUTATE_QUIZ_RESULT]: (state, payload) => {
    state.quiz_result = payload;
  },
  [types.MUTATE_TRYOUT]: (state, payload) => {
    state.tryout = payload;
  },
  [types.MUTATE_TRYOUT_RESULT]: (state, payload) => {
    state.tryout_result = payload;
  },
  [types.MUTATE_TRYOUT_ONGOING]: (state, payload) => {
    state.tryout_ongoing = payload;
  },
  [types.MUTATE_NOTIF]: (state, payload) => {
    if(payload) {
      state.new_notif++
    } else {
      state.new_notif = 0
    }
  }
};

const actions = {
  [types.LOGIN_VERIFY]: (state, credentials) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_URL, credentials)
        .then(response => {
          if (response.data.success) {
            state.commit(types.MUTATE_LOGIN, response.data);
            resolve(response.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch(error => {
          state.commit(types.MUTATE_LOGOUT);
          reject(error.message);
        });
    });
  },
  [types.LOGIN]: (state, credentials) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "auth/login", credentials)
        .then(response => {
          if (response.data.success) {
            state.commit(types.MUTATE_LOGIN, response.data);
            resolve(response.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch(error => {
          state.commit(types.MUTATE_LOGOUT);
          reject(error.message);
        });
    });
  },
  [types.LOGOUT]: ({ commit }, payload) => {
    commit(types.MUTATE_LOGOUT, payload);
  }, 
  [types.UPDATE_NOTIF]: ({ commit }, payload) => {
    commit(types.MUTATE_NOTIF, payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
